<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Empresa from '@/src/services/empresa'

import formEmpresa from '@src/components/form-empresa'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formEmpresa },
  data() {
    return {
      mostraForm: true,
      empresaEdit: {},
      empresas: [],
      empresaFields: [
        {
          key: 'id_empresa',
          label: 'ID',
          class: 'size-col-20',
        },
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
        },
        {
          key: 'cnpj',
          label: 'CNPJ',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      id_empresa: '',
    }
  },
  computed: {},

  watch: {
    currentPage() {
      this.listaEmpresas()
    },
  },
  mounted() {
    this.listaEmpresas()
  },
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listaEmpresas() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Empresa.listar(token, this.perPage, this.currentPage).then((resposta) => {
        this.empresas = resposta.data.dados
        this.rows = resposta.headers['x-total-count']
        this.isLoading = this.loading(this.isLoading)
      })
    },
    editRegister(empresa) {
      this.empresaEdit = empresa
      this.mostraForm = false
    },
    cadastra() {
      if (this.empresaEdit) {
        this.empresaEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listaEmpresas()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.id_empresa = id
    },
    empresaDeletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Empresa.deletar(token, this.id_empresa)
        .then((resposta) => {
          this.listaEmpresas()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.id_empresa = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Empresa</div>
            <div class="subTitulo"
              >Visualize, edite e cadastre novas empresas na plataforma.</div
            >
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <b-table
            striped
            hover
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="empresas"
            :fields="empresaFields"
            :per-page="perPage"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button
                  v-b-tooltip.hover
                  title="Editar"
                  type="button"
                  class="btn btn-light"
                  @click="editRegister(row.item)"
                >
                  <i class="uil uil-edit"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Deletar"
                  type="button"
                  class="btn btn-light"
                  @click="modalDelete(row.item.id_empresa)"
                >
                  <i class="uil uil-trash-alt"></i>
                </button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>

        <div v-else>
          <formEmpresa :empresa="empresaEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="empresaDeletar">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>